var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['label', `label-${_vm.labelClass}`]},[_vm._v(_vm._s(_vm.status.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }